import {STATUS_TYPES, STATUS_LABELS, APPROVAL_LABELS, LABELS, ALERT_MESSAGES} from './PlanStatusTab.constants';

/**
 * Formats a date to locale string
 * @param {string|Date} date - Date to format
 * @returns {string} - Formatted date or 'Not Specified'
 */
export const formatDate = (date) => {
    if (date) return new Date(date).toLocaleDateString();
    return LABELS.NOT_SPECIFIED;
};

/**
 * Gets the appropriate status configuration
 * @param {string} status - Status type
 * @returns {object} - Status chip configuration
 */
export const getStatusConfig = (status) => {
    const configs = {
        [STATUS_TYPES.DRAFT]: { label: STATUS_LABELS.DRAFT, color: 'default', icon: null },
        [STATUS_TYPES.SUBMITTED]: { label: STATUS_LABELS.SUBMITTED, color: 'primary', icon: null },
        [STATUS_TYPES.WAITING_FOR_SUPPORT]: { label: STATUS_LABELS.WAITING_FOR_SUPPORT, color: 'warning', icon: null },
        [STATUS_TYPES.SUPPORT_PROVIDED]: { label: STATUS_LABELS.SUPPORT_PROVIDED, color: 'info', icon: null },
        [STATUS_TYPES.UNDER_REVIEW]: { label: STATUS_LABELS.UNDER_REVIEW, color: 'info', icon: null },
        [STATUS_TYPES.APPROVED]: { label: STATUS_LABELS.APPROVED, color: 'success', icon: 'CheckCircleIcon' },
        [STATUS_TYPES.REJECTED]: { label: STATUS_LABELS.REJECTED, color: 'error', icon: 'WarningIcon' },
        [STATUS_TYPES.REVISION_REQUIRED]: { label: STATUS_LABELS.REVISION_REQUIRED, color: 'warning', icon: null },
        [STATUS_TYPES.PENDING_LOCAL_RISK_ASSESSMENT]: { label: STATUS_LABELS.PENDING_LOCAL_RISK_ASSESSMENT, color: 'info', icon: null },
    };

    return configs[status] || { label: STATUS_LABELS.UNKNOWN, color: 'default', icon: null };
};

/**
 * Gets the appropriate approval configuration
 * @param {boolean|null} approved - Approval status
 * @returns {object} - Approval chip configuration
 */
export const getApprovalConfig = (approved) => {
    if (approved === true) {
        return { label: APPROVAL_LABELS.APPROVED, color: 'success', icon: 'CheckCircleIcon' };
    } else if (approved === false) {
        return { label: APPROVAL_LABELS.NOT_APPROVED, color: 'error', icon: 'WarningIcon' };
    }
    return { label: APPROVAL_LABELS.PENDING, color: 'warning', icon: null };
};

/**
 * Gets the alert configuration for a status
 * @param {string} status - Status type
 * @param {string} planType - Plan type
 * @returns {object|null} - Alert configuration or null
 */
export const getAlertConfig = (status, planType) => {
    switch (status) {
        case STATUS_TYPES.APPROVED:
            return { severity: 'success', icon: 'CheckCircleIcon', ...ALERT_MESSAGES.APPROVED };
        case STATUS_TYPES.UNDER_REVIEW:
            return { severity: 'info', icon: null, ...ALERT_MESSAGES.UNDER_REVIEW };
        case STATUS_TYPES.REJECTED:
            return { severity: 'error', icon: 'WarningIcon', ...ALERT_MESSAGES.REJECTED };
        case STATUS_TYPES.REVISION_REQUIRED:
            return { severity: 'warning', icon: 'WarningIcon', ...ALERT_MESSAGES.REVISION_REQUIRED };
        case STATUS_TYPES.PENDING_LOCAL_RISK_ASSESSMENT:
            return { severity: 'info', icon: null, ...ALERT_MESSAGES.PENDING_LOCAL_RISK_ASSESSMENT };
        case STATUS_TYPES.SUBMITTED:
            return planType === 'EXEMPTION_REQUEST'
                ? null
                : { severity: 'success', icon: 'CheckCircleIcon', ...ALERT_MESSAGES.SUBMITTED_FINAL };
        default:
            return null;
    }
};